import {useRef} from 'react'
import {IconButton} from '@primer/react'
import type {TooltipProps} from '@primer/react/deprecated'
import {Octicon} from '@primer/react/deprecated'

import {ShieldIcon} from '@primer/octicons-react'
import {Link} from '@github-ui/react-core/link'
import {usePortalTooltip} from '@github-ui/portal-tooltip/use-portal-tooltip'
import useIsBranchProtected from '../hooks/use-is-branch-protected'
import type {Branch} from '../types'

import styles from './BranchProtectionShield.module.css'

interface BranchProtectionShieldProps extends Pick<Branch, 'name' | 'rulesetsPath' | 'protectedByBranchProtections'> {
  isLarge: boolean
}

export default function BranchProtectionShield({isLarge, ...branch}: BranchProtectionShieldProps) {
  const {isProtectedBy} = useIsBranchProtected(branch)
  const contentRef = useRef<HTMLDivElement>(null)
  const direction: TooltipProps['direction'] = !isLarge && branch.name.length < 5 ? 'ne' : undefined
  const [contentProps, tooltip] = usePortalTooltip({
    contentRef,
    'aria-label': 'This branch is protected by branch protections',
    direction,
  })

  if (isProtectedBy.branchProtections) {
    return (
      <>
        <div data-testid="branch-protection-shield" ref={contentRef} {...contentProps}>
          <Octicon
            size={16}
            icon={ShieldIcon}
            aria-label="This branch is protected by branch protections"
            className={styles.ShieldIcon}
          />
        </div>
        {tooltip}
      </>
    )
  }

  if (isProtectedBy.rulesets) {
    return (
      <Link to={branch.rulesetsPath!} aria-label="This branch is protected">
        <IconButton variant="invisible" icon={ShieldIcon} aria-label="View rules" />
      </Link>
    )
  }
  return null
}

try{ BranchProtectionShield.displayName ||= 'BranchProtectionShield' } catch {}